module.exports = __webpack_public_path__ + "static/media/check-icon.f0b8d182.svg";